import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { toast } from 'sonner';
import { hapticSuccess } from '../utils/haptics';
import AddBookingWizard from './AddBookingWizard';
import { orgApi } from '../utils/apiV2';
import { useRoles } from '../hooks/useData';
import { createManualBooking } from '../utils/manualBooking';

// Self-contained launcher for the shared Add Booking wizard (Service + Custom).
// Fetches its own assets/team data so any page (Manifest, etc.) can open it.
const AddBookingLauncher = ({ open, onClose, onBookingCreated }) => {
  const { roles } = useRoles();
  const [assets, setAssets] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);

  useEffect(() => {
    if (!open) return;
    let cancelled = false;
    (async () => {
      const [teamRes, assetsRes] = await Promise.allSettled([
        orgApi.getTeamMembers(),
        orgApi.getAssets(),
      ]);
      if (cancelled) return;
      const t = teamRes.status === 'fulfilled' ? teamRes.value : null;
      const a = assetsRes.status === 'fulfilled' ? assetsRes.value : null;
      setTeamMembers(t?.data?.teamMembers || t?.data || []);
      setAssets(a?.data?.assets || a?.data || []);
    })();
    return () => { cancelled = true; };
  }, [open]);

  if (!open) return null;

  return createPortal(
    <AddBookingWizard
      assets={assets}
      teamMembers={teamMembers}
      roles={roles}
      onComplete={async (tripData) => {
        try {
          const booking = await createManualBooking(tripData);
          hapticSuccess();
          if (onBookingCreated) onBookingCreated(booking);
          return booking;
        } catch (error) {
          console.error('Error adding booking:', error);
          toast.error('Failed to add booking');
          throw error;
        }
      }}
      onCancel={onClose}
    />,
    document.body
  );
};

export default AddBookingLauncher;
